// /* eslint-disable */

import ApiService from "./httpService";

const handleInvalidDeviceID = (error) => {
  if (
    error?.response?.data === "Invalid Device ID." ||
    error?.message?.includes("Invalid Device ID") ||
    error === "Invalid Device ID."
  ) {
    alert("Invalid Device ID. Please log in again.");
    localStorage.clear();
    window.location.hash = "#/login"; // Adjust this route as needed
    return true;
  }
  return false;
};

export const AddUser = async (body) => {
  try {
    // Make API request to add a new user
    const data = await ApiService.postPublic("api/Cenpilot/AddUser", body);

    console.log("User data saved successfully:", body);

    // Check if the response contains the expected data
    if (data) {
      return { success: 200, data };
    } else {
      throw new Error("Data was not saved.");
    }
  } catch (error) {
    console.error("Error adding user:", error);

    return { success: 500 };
  }
};

export const AddMaster = async (body) => {
  try {
    // Make API request to add a new master
    const data = await ApiService.postPublic("api/Cenpilot/AddMaster", body);

    if (data === "Invalid Device ID.") {
      alert("Invalid Device ID. Please log in again.");
      localStorage.clear();
      history.push("/login");
      return { success: false };
    }

    console.log("Master data saved successfully:", body);

    // Check if the response contains the expected data
    if (data) {
      return { success: true, data };
    } else {
      throw new Error("Data was not saved.");
    }
  } catch (error) {
    console.error("Error adding user:", error);

    if (
      error?.response?.data === "Invalid Device ID." ||
      error?.message?.includes("Invalid Device ID")
    ) {
      alert("Invalid Device ID. Please log in again.");
      localStorage.clear();
      history.push("/login");
      return { success: false };
    }

    return { success: false };
  }
};

export const AddValve = async (body) => {
  try {
    const data = await ApiService.postPublic("api/Cenpilot/AddValve", body);
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error adding Valve:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const AddNode = async (body) => {
  try {
    const data = await ApiService.postPublic("api/Cenpilot/AddNode", body);
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error adding Node:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const AddPumpServer = async (body) => {
  try {
    const data = await ApiService.postPublic("api/Cenpilot/AddPump", body);
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error adding Pump:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const AddMasterServer = async (body) => {
  try {
    const data = await ApiService.postPublic(
      "api/CenPilot/UpdateUserMaster",
      body
    );
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error adding Master:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const UpdateMasterServer = async (body) => {
  try {
    const data = await ApiService.postPublic(
      `api/CenPilot/UpdateMaster?ID=${body.ID}`,
      body
    );
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error updating Master:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const UpdateUserServer = async (body) => {
  try {
    console.log(body);

    const data = await ApiService.postPublic(
      `api/CenPilot/UpdateUser?ID=${body.id}`,
      body
    );
    console.log("data", data);

    // if (handleInvalidDeviceID(data)) return { success: 500 };
    if (data) return { success: 200, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error updating User:", error);
    if (handleInvalidDeviceID(error)) return { success: 500 };
    return { success: 500 };
  }
};

export const EditValve = async (body) => {
  try {
    const data = await ApiService.postPublic(
      `api/Cenpilot/UpdateValve?ID=${body.Id}`,
      body
    );
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error editing Valve:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const EditNode = async (body) => {
  try {
    const data = await ApiService.postPublic(
      `api/Cenpilot/UpdateNode?ID=${body.Id}`,
      body
    );
    if (handleInvalidDeviceID(data)) return { success: false };
    if (data) return { success: true, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error editing Node:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};

export const EditPump = async (body) => {
  try {
    const data = await ApiService.postPublic(
      `api/CenPilot/PumpUpdate?ID=${body.ID}`,
      body
    );
    if (handleInvalidDeviceID(data)) return { success: 500 };
    if (data) return { success: 200, data };
    throw new Error("Data was not saved.");
  } catch (error) {
    console.error("Error editing Pump:", error);
    if (handleInvalidDeviceID(error)) return { success: 500 };
    return { success: 500 };
  }
};

export const DeleteUser = async (body) => {
  try {
    console.log("body", body);
    console.log("body id", body.ID);
    console.log("body Master", body.Master);

    const data = await ApiService.getPublic(
      `api/CenPilot/RemoveMaster?UserID=${body.ID}&MasterID=${body.Master}`
    );

    if (handleInvalidDeviceID(data)) return { success: 500 };

    console.log("Deleted user data successfully:", body);

    if (data) {
      return { success: 200, data };
    } else {
      throw new Error("Data was not saved.");
    }
  } catch (error) {
    console.error("Error deleting user data:", error);
    if (handleInvalidDeviceID(error)) return { success: 500 };
    return { success: 500 };
  }
};

export const UploadProfileImg = async (body, id) => {
  try {
    console.log(`api/CenPilot/ProfileImage?id=${id}`);

    const data = await ApiService.postPublic(
      `api/CenPilot/ProfileImage?id=${id}`,
      body
    );

    if (handleInvalidDeviceID(data)) return { success: false };

    console.log("Profile image uploaded successfully:", body);

    if (data) {
      return { success: true, data };
    } else {
      throw new Error("Data was not saved.");
    }
  } catch (error) {
    console.error("Error uploading profile image:", error);
    if (handleInvalidDeviceID(error)) return { success: false };
    return { success: false };
  }
};
